












































import { Component, Mixins, Prop } from "vue-property-decorator";
import { RawLocation, Route } from "vue-router";
import { DomainRegistry } from "../../domain";
import { Document, DocumentRegistrationResult } from "../../domain/document";
import { Directory } from "../../domain/drawing";
import { FormatReference } from "../../domain/format";
import { UnmanagedLoginView } from "../authentication";
import { NewDocumentEditor } from "./editors/wizard/guest";
import { GuestWizardDocumentEditViewMixin } from "./mixins";

@Component({
  components: {
    UnmanagedLoginView,
    NewDocumentEditor,
  },
})
export default class GuestWizardNewDocumentEditView extends Mixins(GuestWizardDocumentEditViewMixin) {
  @Prop()
  userCode: string;

  @Prop()
  departmentCode: string;

  @Prop()
  hostName: string;

  @Prop()
  shouldAuthenticateLater: boolean;

  @Prop()
  rootFolderId: string;

  @Prop()
  folderId: string;

  @Prop()
  formatId: number;

  @Prop()
  chainedFormatIds: number[];

  @Prop()
  institutionNo: string;

  @Prop()
  regionalInstitutionNo: string;

  @Prop()
  hisInfoGetterParameter: string;

  @Prop()
  systemKey: string;

  @Prop()
  linkKey: string;

  @Prop()
  orderNo: string;

  @Prop()
  validateRegistration: (source: Document, isTemporary: boolean, isPublish: boolean) => Promise<{ isOk: boolean, notification?: { overview: string, description: string } }>;

  @Prop()
  postRegistrationProcess: (id: number) => Promise<void>;

  @Prop({ default: false })
  shouldValidateExistingLinkedDocument: boolean;

  @Prop()
  shouldSelectDepartment: boolean;

  @Prop()
  loadWizardTemplates: (key: string) => Promise<Directory<string, FormatReference>[]>;

  $refs!: {
    authenticator: UnmanagedLoginView,
  };

  data() {
    return {
      isRegistered: false,
    };
  }
  isRegistered: boolean;

  async beforeEnter(to: Route): Promise<RawLocation> {
    if (to.query.receptionId || to.query.receptionDetailId) {
      // 暫定対応。将来的にはWF用にdispatchする。
      return {
        path: "/Error",
        query: {
          url: to.fullPath,
          message: "ワークフロー文書のため編集できません。",
        }
      };
    }
  }

  authenticate(isForcibly: boolean): Promise<boolean> {
    return this.$refs.authenticator.authenticate(isForcibly);
  }

  async doAuthenticate(userId: string, password: string): Promise<void> {
    await DomainRegistry.instance.document.getAuthenticationService().authenticateWizard(userId, password);
  }

  async validateSelectedFormat(format: any): Promise<boolean> {
    return this.validateFormat(format, false);
  }

  async validateAndRegisterDocument(source: Document, isTemporary: boolean, isPublish: boolean): Promise<DocumentRegistrationResult> {
    if (this.validateRegistration) {
      const result = await this.validateRegistration(source, isTemporary, isPublish);
      if (!result.isOk) {
        // メッセージは利用側で出す.
        const notification = result.notification
          ? result.notification
          : {
            overview: "登録中断",
            description: "登録を中断しました",
          };
        this.$warn(notification.overview, notification.description);
        throw new Error(notification.overview);
      }
    }
    return this.registerDocument(source, isTemporary, isPublish);
  }

  async onDocumentRegistered(id: number, destinationRoute?: any, isTemporary?: boolean, archiveId?: number): Promise<void> {
    this.isEditing = false;
    this.isRegistered = true;
    this.notifyRegisteredMessage();
  }
}
